import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import { DropzoneFile } from 'components/Dropzone/utils';

import './PreviewNbioModal.styles.scss';

type PreviewNbioModalProps = {
  className?: string;
  nbio: DropzoneFile;
} & ModalProps;

const PreviewNbioModal: React.ForwardRefRenderFunction<
  ModalRef,
  PreviewNbioModalProps
> = (props, ref) => {
  const { children, className, nbio, ...rest } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('preview-nbio-modal', className);

  const { t } = useTranslation();

  return (
    <Modal ref={modalRef} className={classes} title={t('NBIO')} {...rest}>
      <iframe src={nbio?.url} key={nbio?.key} title={nbio?.name} />
      {children}
    </Modal>
  );
};

export default forwardRef(PreviewNbioModal);
